import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataLivingRelationshipSchema = validator.object().shape({
  relationship: validator.string().emptyToNull().label("続柄").required(),
  xLivingRelationshipRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(2)
    .label("期間更新CSVのコード（列X）")
    .required(),
});
